import { INJURY_POST_DECEASED } from 'containers/PreOpeningPage/constants';
import { first, get, isEmpty, orderBy } from 'lodash';
import { RcCorporeal } from 'containers/CourtManagerLegalProceedings/Provision/Regulation/typings';
import {
  filterCanceledRegulations,
  isMinor,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/utils';
import {
  REGULATIONS,
  REGULATION_AMOUNTS,
} from 'containers/CourtManagerLegalProceedings/Provision/Regulation/data-structure';
import { SagisConfig } from 'containers/AppContainer/typings';
import { VictimType } from 'typings/globalTypes';
export const getTheLatestEvaluation = (
  victimKey: string = '',
  dahirAmounts: any = [],
) => {
  const evaluations = dahirAmounts
    .map((item: any) => {
      return item.victimKey === victimKey
        ? { evaluationDate: item.evaluationDate, rcAmount: item.rcAmount }
        : null;
    })
    .filter((item: any) => !isEmpty(item));
  const result = !isEmpty(evaluations)
    ? evaluations.reduce((previous: any = {}, current: any = {}) => {
        return get(previous, 'evaluationDate', '') >
          get(current, 'evaluationDate', '')
          ? previous
          : current;
      })
    : {};

  return get(result, 'rcAmount', '');
};
export const hasCompanyAmount = (rcCorpo: RcCorporeal, lossDate: string) => {
  return get(rcCorpo, 'data', []).every((victim: VictimType) => {
    const showCompanyAmount =
      victim.injuryPostKey !== INJURY_POST_DECEASED &&
      isMinor(
        victim,
        { victim },
        rcCorpo,
        get(rcCorpo.regulationInfo, REGULATIONS.REGULATION_DATE, []),
      );
    return showCompanyAmount &&
      !isEmpty(get(victim?.regulationAmount, REGULATION_AMOUNTS.COMPANY_AMOUNT))
      ? true
      : !showCompanyAmount
      ? true
      : false;
  });
};
export const getLatestRegulations = (regulations: any) => {
  const orderRegulation = orderBy(regulations, ['regulationDate'], ['desc']);
  const latestVictimDetails = orderRegulation.flatMap(item =>
    item?.documentChiffre?.documentChiffreCorporel?.documentHeader?.victimsDetailModel.map(
      (el: any) => ({
        ...el,
        paymentId: item?.paymentId,
        paymentStatusCode: item?.paymentStatusCode,
      }),
    ),
  );
  return latestVictimDetails;
};
export const getExecutionByVictim = (
  regulations: any,
  victim: VictimType,
  paymentStatus: SagisConfig[],
  beneficiary: any = {},
  fees?: String,
) => {
  if (!isEmpty(regulations)) {
    const latestVictimDetails = getLatestRegulations(
      filterCanceledRegulations(paymentStatus, regulations || []),
    );
    const result = !isEmpty(beneficiary)
      ? latestVictimDetails.filter((e: any) => {
          return e?.nextOfKinKey === 0
            ? e?.victimKey === parseInt(victim?.victimKey)
            : e?.nextOfKinKey === parseInt(beneficiary?.nextOfKinKey);
        })
      : latestVictimDetails.filter(
          (e: any) => e?.victimKey === parseInt(victim?.victimKey),
        );
    const resultFees = result.filter(item => item.nextOfKinName === fees);
    return !isEmpty(beneficiary) && !fees
      ? first(result.filter(item => !!item.nextOfKinKey))
      : !isEmpty(beneficiary) && fees
      ? first(resultFees)
      : first(result);
  }
};

export const mapVictimAmounts = (rcCorporealData: any[]) => {
  const victims = rcCorporealData || [];
  return victims.reduce((acc: Record<string, any>, victim: any) => {
    const key = victim.victimKey;

    acc[key] = {
      compensationAmount: victim?.regulationAmount?.compensationAmount ?? null,
      appealAmount: victim?.regulationAmount?.appealAmount ?? null,
      medicalFees: victim?.regulationAmount?.medicalFees ?? null,
      companyAmount: victim?.regulationAmount?.companyAmount ?? null,
      funeralFees: victim?.regulationAmount?.funeralFees ?? null,
    };

    return acc;
  }, {});
};

export const isLatestRegulationExistBawaba = (
  regulationsBawaba: any,
  regulations: any,
  paymentStatus: any,
  victim: VictimType,
) => {
  const bawabaSagisRegulationIds = regulationsBawaba?.map(
    (el: any) => el.sagisRegulationId,
  );
  return bawabaSagisRegulationIds?.includes(
    get(
      getLatestRegulations(
        filterCanceledRegulations(paymentStatus, regulations || []),
      ).filter((e: any) => e?.victimKey === parseInt(victim?.victimKey)),
      '[0].paymentId',
    ),
  );
};
